var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"playground"}},[_c('iframe',{attrs:{"src":"/thoughts/开始创作.html","frameborder":"0","height":"100%","width":"100%"}})])}]

export { render, staticRenderFns }